import React from 'react';
import { track } from '../lib/analytics';

const PractitionerCallout = () => {
  return (
    <section
      data-testid="practitioner-callout"
      style={{
        padding: '64px 24px',
        background: 'var(--yup-surface)',
        borderTop: '1px solid var(--yup-border)',
        borderBottom: '1px solid var(--yup-border)',
      }}
    >
      <div
        style={{
          maxWidth: '760px',
          margin: '0 auto',
          textAlign: 'center',
        }}
      >
        <p
          className="yup-eyebrow"
          style={{ marginBottom: '14px', color: 'var(--yup-warm)' }}
        >
          For practitioners
        </p>
        <h3
          className="font-serif"
          style={{
            fontSize: 'clamp(22px, 3.4vw, 32px)',
            fontWeight: 300,
            lineHeight: 1.3,
            color: 'var(--yup-ink)',
            marginBottom: '16px',
            letterSpacing: '-0.3px',
          }}
        >
          Therapist, coach, breathwork facilitator, somatic worker?
          <br />
          <em style={{ fontStyle: 'italic', color: 'var(--yup-accent)' }}>
            Pause here.
          </em>
        </h3>
        <p
          style={{
            fontSize: '15px',
            color: 'var(--yup-muted)',
            lineHeight: 1.8,
            marginBottom: '24px',
          }}
        >
          YUP isn't built to replace the work you do — it's built to be{' '}
          <strong style={{ color: 'var(--yup-ink)', fontWeight: 500 }}>
            supported by it
          </strong>
          . If your work aligns with one of the six pillars and you'd like to
          be part of how this gets delivered, we'd genuinely like to hear from
          you.
        </p>
        <a
          href="/supporters"
          data-testid="practitioner-callout-cta"
          onClick={() => track('practitioner_callout_click', { value: 'inline' })}
          style={{
            display: 'inline-block',
            background: 'transparent',
            color: 'var(--yup-ink)',
            border: '1px solid var(--yup-ink)',
            padding: '14px 32px',
            fontSize: '12px',
            fontWeight: 500,
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            textDecoration: 'none',
            transition: 'background 0.2s, color 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'var(--yup-ink)';
            e.currentTarget.style.color = 'var(--yup-bg)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.color = 'var(--yup-ink)';
          }}
        >
          Get in touch →
        </a>
      </div>
    </section>
  );
};

export default PractitionerCallout;
